import React from "react";

interface Props {
  disabled?: boolean;
  label: string;
  onClick: () => void;
}

const Button: React.FC<Props> = ({ label, onClick, disabled = false }) => {
  return (
    <button
      onClick={onClick}
      disabled={disabled}
      className={`px-4 py-2 rounded-md shadow transition duration-200
        ${
          disabled
            ? "bg-slate-100 text-slate-400 cursor-not-allowed"
            : "bg-slate-200 text-slate-900 hover:bg-slate-300"
        }
      `}
    >
      {label}
    </button>
  );
};

export default Button;
